import { useEffect, useState } from "react";
import { AdminService } from "../../core/services/AdminService";
import usePaginator from "../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { _single } from "../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../theme/Component/BasicTable";

interface QueryParams {
    command: string;
    order: string;
    rows: number;
}

export const ExecuteCommand = () => {
    const service = new AdminService();
    const paginador = usePaginator();

    const [command, setCommand] = useState<string>("");
    const [order, setOrder] = useState<string>("");
    const [page, setPage] = useState<number>(1);
    const [rows, setRows] = useState<number>(15);

    const [activeQuery, setActiveQuery] = useState<QueryParams | null>(null);
    const [lista, setLista] = useState<any[]>([]);
    const [head, setHead] = useState<any[]>([]);

    useEffect(() => {
        makehead();
    }, [lista]);

    useEffect(() => {
        if (activeQuery) {
            fetchData();
        }
    }, [activeQuery, paginador.page]);

    const makehead = () => {
        const h: string[] = [];
        if (Array.isArray(lista)) {
            lista.forEach((element) => {
                if (element?.DataBeanProperties) {
                    Object.keys(element.DataBeanProperties).forEach((key) => {
                        if (!h.includes(key)) {
                            h.push(key);
                        }
                    });
                }
            });
        }

        const headTable = h.map((key) => ({
            title: key,
            property: key,
            visible: true
        }));
        setHead(headTable);
    };

    const sanitizeSql = (sql: string): string => {
        if (!sql) return "";
        let clean = sql;
        // 1. Reemplazar comillas tipográficas/curvas por comillas simples y dobles estándar
        clean = clean.replace(/[“”]/g, '"').replace(/[‘’]/g, "'");
        
        // 2. Reemplazar espacios invisibles y espacios duros (\u00A0) por espacios normales
        clean = clean.replace(/[\u00A0\u200B\u200C\u200D\uFEFF]/g, " ");
        
        // 3. Normalizar saltos de línea (convertir \r\n y \r en \n)
        clean = clean.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        
        // 4. Limpiar espacios extras al final de cada línea y en los extremos del query
        clean = clean.split("\n").map(line => line.trimEnd()).join("\n").trim();
        
        return clean;
    };

    const handleExecute = () => {
        const sanitized = sanitizeSql(command);
        if (sanitized !== "") {
            setActiveQuery({ command: sanitized, order, rows: rows ?? 15 });
            paginador.setPage(1);
        } else {
            toast.warning("Debe ingresar un comando SQL");
        }
    };

    const fetchData = () => {
        if (!activeQuery) return;

        _single.spinner(true);
        service.executeCommand(
            paginador.page,
            activeQuery.rows,
            activeQuery.command,
            "1"
        ).subscribe({
            next: (resp: any) => {
                if (resp.DataBeanProperties.ErrorMessage) {
                    toast.error(resp.DataBeanProperties.ErrorMessage);
                } else if (resp.DataBeanProperties.ObjectValue) {
                    const data = resp.DataBeanProperties.ObjectValue;
                    setLista(data.DataBeanProperties.List ?? []);
                    paginador.setPages(data.DataBeanProperties.NumberOfPages ?? 0);
                }
                _single.spinner(false);
            },
            error: (err: any) => {
                console.error("Error al ejecutar comando SQL:", err);
                toast.error("Ocurrió un error de red o del servidor al procesar la solicitud.");
                _single.spinner(false);
            }
        });
    };

    return (
        <div className="row">
           
          
            <div className="col-md-3">
                <label> Registros</label>
                <input
                    type="number"
                    className="form-control"
                    value={rows}
                    onChange={(e) => setRows(parseInt(e.target.value) || 15)}
                />
            </div>
            <div className="col-md-12">
                <label>Comando</label>
                <textarea
                    className="form-control"
                    name="command"
                    id="command"
                    value={command}
                    onChange={(e) => setCommand(e.target.value)}
                />
            </div>
            <div className="col-md-12 mt-3">
                <button
                    className="btn btn-primary"
                    disabled={command.trim() === ""}
                    onClick={handleExecute}
                >
                    Ejecutar
                </button>
            </div>
            <div className="col-md-12">
                {head.length > 0 && (
                    <BasicTable
                        head={head}
                        body={lista}
                        rowSet={(e) => _single.printOut(e)}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        customRows={rows}
                    />
                )}
            </div>
        </div>
    );
};